import { SIDEBAR_COLLAPSED_STORAGE_KEY } from 'constants/layout';
import { setSessionStorageValue } from 'helpers/sessionStorage';

import type { ThunkAction } from '../types';
import { RESTORE_PREV_SIDEBAR_STATE, TOGGLE_SIDEBAR } from './actionTypes';
import { getIsSidebarCollapsed } from './selectors';

export const toggleSidebar = (): ThunkAction => (dispatch, getState) => {
  const isCollapsed = !getIsSidebarCollapsed(getState());
  setSessionStorageValue(SIDEBAR_COLLAPSED_STORAGE_KEY, isCollapsed);

  return dispatch({
    type: TOGGLE_SIDEBAR,
    payload: {
      isCollapsed,
      prevState: undefined,
    },
  });
};

export const collapseSidebarTemporarily = (): ThunkAction => (dispatch, getState) => {
  const isCollapsed = getIsSidebarCollapsed(getState());

  if (isCollapsed) {
    return;
  }

  return dispatch({
    type: TOGGLE_SIDEBAR,
    payload: {
      isCollapsed: true,
      prevState: getIsSidebarCollapsed(getState()),
    },
  });
};

export const restoreSidebarState = () => ({
  type: RESTORE_PREV_SIDEBAR_STATE,
});
